document.addEventListener("DOMContentLoaded", () => {
  (function () {
    const animHome = document.querySelector(".anim-home");
    if (!animHome) return;

    function getElementVisibilityPercentage(selector) {
      const element = document.querySelector(selector);
      if (!element) return;

      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth;

      const visibleHeight = Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
      const visibleWidth = Math.max(0, Math.min(rect.right, windowWidth) - Math.max(rect.left, 0));
      const elementArea = rect.width * rect.height;
      const visibleArea = visibleWidth * visibleHeight;

      return elementArea > 0 ? (visibleArea / elementArea) * 100 : 0;
    }

    function startAnimation() {
      const chartImg = animHome.querySelector(".chart-img");
      const content = animHome.querySelector(".content");
      const shadow1 = animHome.querySelector(".shadow-1");
      const shadow2 = animHome.querySelector(".shadow-2");
      const line = animHome.querySelector(".chart-line-wrapper");
      const cirlce = animHome.querySelector(".circle-pulse");
      const flyLabel = animHome.querySelector(".fly-label");

      function setTimeoutActionClassName(action, element, className, timeout) {
        setTimeout(() => {
          document.querySelector(element).classList[action](className);
        }, timeout);
      }

      setTimeoutActionClassName("add", ".chart-img", "active", 200);
      setTimeoutActionClassName("add", ".content", "active", 300);
      setTimeoutActionClassName("add", ".chart-bg", "active", 500);

      setTimeout(() => {
        line.style.width = "25%";
        cirlce.classList.add("poz-1");
        flyLabel.classList.add("poz-1");
      }, 800);

      setTimeout(() => {
        line.style.width = "40%";
        cirlce.classList.add("poz-2");
        flyLabel.classList.add("poz-2");
      }, 1900);

      setTimeout(() => {
        line.style.width = "62%";
        cirlce.classList.add("poz-3");
        flyLabel.classList.add("poz-3");
      }, 3400);

      // Shadow
      setTimeout(() => {
        shadow1.classList.add("active");
        setTimeoutActionClassName("remove", ".shadow-1", "active", 1000);
      }, 1500);

      setTimeout(() => {
        shadow1.classList.add("active");
        setTimeoutActionClassName("remove", ".shadow-1", "active", 1000);
      }, 3000);

      setTimeout(() => {
        shadow1.classList.add("active");
        setTimeoutActionClassName("remove", ".shadow-1", "active", 1000);
      }, 3800);

      // Shadow 2
      setTimeout(() => {
        shadow2.classList.add("active");
        setTimeoutActionClassName("remove", ".shadow-2", "active", 1300);
      }, 1500);

      setTimeout(() => {
        shadow2.classList.add("active");
        setTimeoutActionClassName("remove", ".shadow-2", "active", 1300);
      }, 3000);

      setTimeout(() => {
        shadow2.classList.add("active");
        setTimeoutActionClassName("remove", ".shadow-2", "active", 1300);
      }, 3800);
    }

    let animStart = false;

    function checkStartAniation() {
      const visibilityPercentage = getElementVisibilityPercentage(".anim-home");

      if (visibilityPercentage > 70) {
        animStart = true;
        startAnimation();
      } else {
        document.addEventListener("scroll", onScroll);
      }
    }

    function onScroll() {
      if (!animStart) {
        const visibilityPercentage = getElementVisibilityPercentage(".anim-home");
        if (visibilityPercentage > 70) {
          animStart = true;
          startAnimation();
          document.removeEventListener("scroll", onScroll); // Usuwamy nasłuchiwacz po uruchomieniu animacji
        }
      }
    }

    checkStartAniation();
  })();
});
